module.exports = __webpack_public_path__ + "models/transbgm.00def4d.txt";